import React, { useState, useEffect } from 'react';
import './RotatingWord.css';

const RotatingWord = ({ words, interval = 3000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setIsAnimating(true);
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % words.length);
        setIsAnimating(false);
      }, 500); // Half of animation duration
    }, interval);

    return () => clearInterval(timer);
  }, [words.length, interval]);

  return (
    <span className={`rotating-word ${isAnimating ? 'animating' : ''}`}>
      <span className="rotating-word-text">{words[currentIndex]}</span>
    </span>
  );
};

export default RotatingWord;

